import { render } from "./GrTMain.vue?vue&type=template&id=616d1715&scoped=true"
import script from "./GrTMain.vue?vue&type=script&lang=js"
export * from "./GrTMain.vue?vue&type=script&lang=js"

import "./GrTMain.vue?vue&type=style&index=0&id=616d1715&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616d1715"]])

export default __exports__